module.exports = __webpack_public_path__ + "img/tesla.8687fe06.png";